"use strict";

exports.__esModule = true;
exports.MapPartInstanceUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _MapPartInstanceUserActionElement = require("./MapPartInstanceUserActionElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MapPartInstanceUserAction = exports.MapPartInstanceUserAction = {
  name: "MapPartInstance",
  icon: "cog",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MapPartInstanceUserAction.label",
    defaultMessage: "Map Part Instance"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MapPartInstanceUserAction.description",
    defaultMessage: "Define Part Instance mapping"
  }),
  requiresContexts: ["device"],
  requiresProps: [],
  components: {
    Element: _MapPartInstanceUserActionElement.MapPartInstanceActionElement
  }
};